import { render, staticRenderFns } from "./MatterListView.vue?vue&type=template&id=28a3a5a7&scoped=true"
import script from "./MatterListView.vue?vue&type=script&lang=js"
export * from "./MatterListView.vue?vue&type=script&lang=js"
import style0 from "./MatterListView.vue?vue&type=style&index=0&id=28a3a5a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a3a5a7",
  null
  
)

export default component.exports